import { useResource } from "../../../Hooks/UseResource";

export default function KycGuideResource() {
    const[resourceError, loading, getData, postData] =useResource();
    
   const acceptTermsAndConditions = (applicationSessionToken) => {
        return postData({url :'public/kyc-tc-accepted' , data:{"appKey" :applicationSessionToken}})
   }

    return [acceptTermsAndConditions]

}